var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"newsletter-signup banner",attrs:{"width":"sm"}},[_c('NewsletterSignup',{staticClass:"container",attrs:{"slice-data":_vm.slice.primary,"full-width":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }